module.exports = __webpack_public_path__ + "img/icon-weizhang.e6a48c75.png";